<template>
  <v-card>
    <v-card-title :class="`${colorClassForContractType(contractType)} white--text headline`">
      {{ $t('deductingActivities') }}
      <v-spacer/>
      <BaseDialogActions
      hideRefresh
      hideFullscreen
      @close="$emit('close')"/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
      @submit="submitDeductions"
      :buttonColor="colorClassForContractType(contractType)"
      :buttonText="$t('done')">
        <v-row class="mt-2">
          <v-col cols="11">
            <v-autocomplete
            :label="$t('deductingActivities')"
            :items="filteredBuilders"
            item-value="activityBuilderId"
            multiple
            chips
            :item-text="deductingBuilderText"
            v-model="deductingBuilderIds"
            />
          </v-col>
        </v-row>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>
<script>
import { colorClassForContractType } from '@/utils/componentHelpers.js'
import { TemplateAccountingCategory, TemplateSpecialization, RecoveryMode, CostType, RuntimeCounterparty } from '@/utils/Enumerations.js'
export default {
  name: 'DeductingActivities',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    contractType: Object,
    propBuilder: Object,
    builders: Array,
    stringFromBuilder: Function
  },

  data: () => ({
    deductingBuilderIds: []
  }),

  watch: {
    propBuilder: {
      immediate: true,
      deep: true,
      handler (newBuilder) {
        this.deductingBuilderIds = newBuilder.deductingBuilderIds.slice()
      }
    }
  },

  computed: {
    filteredBuilders () {
      return this.builders.filter(b => b.activityBuilderId !== this.propBuilder.activityBuilderId &&
        b.category === TemplateAccountingCategory.AccountsPayable.value &&
        b.specialization === TemplateSpecialization.None.value &&
        b.deductingBuilderIds.length === 0 &&
        b.recoveryMode.value === RecoveryMode.None.value &&
        b.costBehavior === CostType.Production.value &&
        b.runtimeField !== RuntimeCounterparty.Landowner.value
      )
    }
  },

  methods: {
    colorClassForContractType,
    submitDeductions () {
      this.$emit('update-deductions', this.deductingBuilderIds)
    },
    deductingBuilderText (builder) {
      return `${builder.activityTemplateName} (${this.stringFromBuilder(builder)})`
    }
  }
}
</script>
